import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useResolvedVoucherDiscount } from './useResolvedVoucherDiscount';

/**
 * Determines if we want to display price in the voucher bigger than main product price
 */
export const useHasStressOnVoucherDiscount = () => {
  const { voucherNewDesign } = useFeatureFlags();
  const voucherDiscount = useResolvedVoucherDiscount();

  if (!voucherDiscount || !voucherNewDesign) {
    return false;
  }

  // Here you can add additional logic for putting stress on price inside voucher component, e.g.:
  //
  // return isConditionalDiscount(voucherDiscount)
  //        ? isConditionalVoucherDiscountDisplayable(voucherDiscount) && voucherDiscount.discountType === 'Percentage'
  //        : voucherDiscount.displayType === 'DiscountedPrice';
  return true;
};
